"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationModalHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _TeamsLogo = _interopRequireDefault(require("assets/img/TeamsLogo.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TeamsIntegrationModalHeader = exports.TeamsIntegrationModalHeader = function TeamsIntegrationModalHeader(_ref) {
  var callbackClose = _ref.callbackClose,
    step = _ref.step;
  var isTeamsLogoVisible = step === "fileList" || step === "metadata" || step === "review";
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "modal-kb-header flow-column",
    gap: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex space-between"
  }, isTeamsLogoVisible && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _TeamsLogo["default"],
    alt: "teams icon",
    width: "20px",
    height: "20px",
    style: {
      marginRight: "5px"
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontSize: "20px"
  }, "Teams Import")), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackClose();
    },
    "data-testid": "modalTeamsIntegration-close-button",
    className: "close_icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 30,
    color: "#000000"
  }))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex space-between"
  }, step === "metadata" && /*#__PURE__*/_react["default"].createElement(_material.Typography, null, "Select file(s) on the left-hand side then add details on the right. Click \"Save\" when completed for all file attachments."), step === "review" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, "Review and confirm the following information."), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "carbon:warning",
    height: 14
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    marginLeft: "5px"
  }, "Previously uploaded files will be replaced if they already exist in the same directory")))));
};